import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../index";
import * as urlService from "../view/urlService";

export const useRecentViolationsTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onDeviceClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('device')
        })
    }

    const onRuleNameClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('rule')
        })
    }

    const onDetailsClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('details')
        })
    }

    const onTypeClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('recordType')
        })
    }

    const onExpectedResultClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('expectedOutput')
        })
    }

    const onViolationDateClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('startTime')
        })
    }

    const onUserClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('user')
        })
    }

    const onSeverityClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('severity')
        })
    }

    const onValidClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('valid')
        })
    }

    //TODO add on backend an remove comment
    const onGroupClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('group')
        })
    }

    return {
        hardReload, onDeviceClick, onRuleNameClick, onDetailsClick, onExpectedResultClick, onViolationDateClick, onUserClick,
        onSeverityClick, onValidClick, onGroupClick, onTypeClick
    }
}
